/**
 * Inicializa o Google Analytics (gtag.js).
 *
 * Só injeta o script quando um measurement ID é fornecido (explicitamente
 * ou via REACT_APP_GA_ID). Isso permite que ambientes como homologação
 * (.env.homolog) fiquem sem a variável definida e não enviem tráfego de
 * teste para as métricas reais de produção.
 *
 * @param {string} [measurementId] ID de medição do GA (ex: "G-XXXXXXX").
 *   Por padrão usa `process.env.REACT_APP_GA_ID`.
 * @returns {void}
 */
export function initGoogleAnalytics(measurementId = process.env.REACT_APP_GA_ID) {
  if (!measurementId || window.__gaInitialized) {
    return;
  }

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  window.__gaInitialized = true;
}
